import React from "react";
import  { FunctionComponent } from "react";
import { TableContents } from '../TableContents';
import { KEYS_VEHICLE } from "../utils/KeysList"
import { Vehicle } from "../../../@types/SinisterFormTypes";
import { ItemGroup } from "../ItemGroup";
import { useStyles } from "../styles";
// import "./styles.css"
interface Props {
  data: Vehicle[]
}

export const VehicleTables: FunctionComponent<Props> = ({ data })  => {
  const styles = useStyles();
  const list = data.map((vehicle, index) =>{

    let estrutura = vehicle["Formulario de Dano"]?.structure != ""?  vehicle["Formulario de Dano"]?.structure: "Não informado"
    let DamageType = vehicle["Formulario de Dano"]?.DamageType != ""?  vehicle["Formulario de Dano"]?.DamageType: "Não informado"
    let DamageFormDetails = vehicle["Formulario de Dano"]?.DamageFormDetails.length? vehicle["Formulario de Dano"]?.DamageFormDetails: null
    console.log("DamageFormDetails",DamageFormDetails);
    
    return (
    <div className={styles.subItemWrapper} key={index}>
      <div className={styles.subItemHeader}>
        <span>
          <b>Veículo {data.indexOf(vehicle) + 1}</b>
        </span>
        <strong>Placa:</strong>
        <span> {vehicle.Placa? vehicle.Placa: "Não Informada"}</span>
      </div>

      <div className={styles.subItemInfo}>
        <ItemGroup title={"Tipo Veículo"} value={vehicle["Tipo Veículo"]} />
        <ItemGroup title={"Ano Fabricação"} value={vehicle["Ano Fabricação"]?vehicle["Ano Fabricação"]:"Não informado"} />
        <ItemGroup title={"Espécie"} value={vehicle.Espécie} />
        <ItemGroup title={"Aluguel"} value={vehicle.Aluguel}/>
        <ItemGroup title={"Cor"} value={vehicle.Cor?vehicle.Cor:"Não informado"}/>
        <ItemGroup title={"Manobra Realizada"} value={vehicle.Manobra?vehicle.Manobra:"Não informado"}/>
        <ItemGroup title={"Marca"} value={vehicle.Marca?vehicle.Marca:"Não informado"}/>
        <ItemGroup title={"Danificado"} value={vehicle.Danificado}/>
        <ItemGroup title={"Categoria"} value={vehicle.Categoria}/>
        <ItemGroup title={"Estrutura"} value={estrutura}/>
        <ItemGroup title={"Legalizado"} value={vehicle.Legalizado}/>
        <ItemGroup title={"Categoria de Dano"} value={DamageType}/>
      </div>
      <div className={styles.damageFormTableWrapper}>
        <div className={styles.damageFormHeader}>
        <strong>Formulário de avaria</strong>
        {!DamageFormDetails&&<span>  Indisponivel</span>}
        </div>
        <div className={styles.damageFormTableContent}>
        {DamageFormDetails && vehicle ["Formulario de Dano"].DamageFormDetails.map((item, Itemindex)=>{
          return(<div key={Itemindex} className={styles.damageTableGroup} style={{backgroundColor:"rgba(252, 181, 29, 0.5)",}}>
            <samp>{item.label}</samp>
            <samp className={styles.itemInfoValue}>{item.answer}</samp>
          </div>)
        })}
        
        </div>
      </div>
    </div>
  );
});

return <>{list}</>;
};
